// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon_icon__IsBEV","customIcon":"icon_customIcon__QrTEy"};